'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SPID_START = exports.SPID_START = 'SPID_START';
var SPID_INIT = exports.SPID_INIT = 'SPID_INIT';
var SPID_INIT_COMPLETE = exports.SPID_INIT_COMPLETE = 'SPID_INIT_COMPLETE';
var SPID_HAS_SESSION = exports.SPID_HAS_SESSION = 'SPID_HAS_SESSION';
var SPID_HAS_SESSION_COMPLETE = exports.SPID_HAS_SESSION_COMPLETE = 'SPID_HAS_SESSION_COMPLETE';
var SPID_HAS_SESSION_ERROR = exports.SPID_HAS_SESSION_ERROR = 'SPID_HAS_SESSION_ERROR';
var SPID_HAS_PRODUCT = exports.SPID_HAS_PRODUCT = 'SPID_HAS_PRODUCT';
var SPID_HAS_ANY_PRODUCT = exports.SPID_HAS_ANY_PRODUCT = 'SPID_HAS_ANY_PRODUCT';
var SPID_HAS_PRODUCT_COMPLETE = exports.SPID_HAS_PRODUCT_COMPLETE = 'SPID_HAS_PRODUCT_COMPLETE';
var SPID_HAS_PRODUCT_ERROR = exports.SPID_HAS_PRODUCT_ERROR = 'SPID_HAS_PRODUCT_ERROR';
var SPID_LOGOUT = exports.SPID_LOGOUT = 'SPID_LOGOUT';
var SPID_LOGIN = exports.SPID_LOGIN = 'SPID_LOGIN';
var SPID_GENERATE_URLS = exports.SPID_GENERATE_URLS = 'SPID_GENERATE_URLS';
var SPID_SUBSCRIBE_EVENTS = exports.SPID_SUBSCRIBE_EVENTS = 'SPID_SUBSCRIBE_EVENTS';

var SPID_EVENT_NOTLOGGEDIN = exports.SPID_EVENT_NOTLOGGEDIN = 'SPID_EVENT_NOTLOGGEDIN';
var SPID_EVENT_STATUS_CHANGE = exports.SPID_EVENT_STATUS_CHANGE = 'SPID_EVENT_STATUS_CHANGE';
var SPID_EVENT_LOGIN = exports.SPID_EVENT_LOGIN = 'SPID_EVENT_LOGIN';
var SPID_EVENT_LOGOUT = exports.SPID_EVENT_LOGOUT = 'SPID_EVENT_LOGOUT';
var SPID_EVENT_USER_CHANGE = exports.SPID_EVENT_USER_CHANGE = 'SPID_EVENT_USER_CHANGE';
var SPID_EVENT_SESSION_INIT = exports.SPID_EVENT_SESSION_INIT = 'SPID_EVENT_SESSION_INIT';
var SPID_EVENT_SESSION_CHANGE = exports.SPID_EVENT_SESSION_CHANGE = 'SPID_EVENT_SESSION_CHANGE';
var SPID_EVENT_VISITOR = exports.SPID_EVENT_VISITOR = 'SPID_EVENT_VISITOR';
var SPID_EVENT_SESSION_ERROR = exports.SPID_EVENT_SESSION_ERROR = 'SPID_EVENT_SESSION_ERROR';
//# sourceMappingURL=types.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/redux-spid/lib/cjs/types.js
 ** module id = 102
 ** module chunks = 0
 **/